import { gql, TypedDocumentNode } from '@apollo/client'

export type NotificationUpdateInput = {
  id: string
  archived?: boolean
  visited?: boolean
  originatorId?: string
}

export type NotificationBulkUpdateInput = {
  notificationUpdates: NotificationUpdateInput[]
}

export const UPDATE_BACKGROUND_NOTIFICATION: TypedDocumentNode<
  { updateBackgroundNotificationsByIds: { id: string } },
  { notificationBulkUpdate: NotificationBulkUpdateInput }
> = gql`
  mutation updateBackgroundNotificationsByIds(
    $notificationBulkUpdate: NotificationBulkUpdateInput!
  ) {
    updateBackgroundNotificationsByIds(
      notificationBulkUpdate: $notificationBulkUpdate
    ) {
      id
    }
  }
`
